import { useEffect, useState } from "react";
import Lunar2025service from "../services/lunar2025.service";
import {
  Col,
  Row,
  Table,
  Form,
  Card,
  Tab,
  Toast,
  Button,
} from "react-bootstrap";
import Loading from "components/Util/Loading";
import Pagination from "components/Util/Pagination";
import lunar2025Service from "../services/lunar2025.service";

export default function Lunar2025(props) {
  const { consumer, currentUser } = props;
  const [collect, setCollect] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 100,
    },
    loading: false,
  });
  const [coinCollect, setCoinCollect] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 100,
    },
    loading: false,
  });

  const [spend, setSpend] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 100,
    },
    loading: false,
  });
  const [coinSpend, setCoinSpend] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 100,
    },
    loading: false,
  });

  const [purchase, setPurchase] = useState({
    list: [],
    pagination: {
      offset: 0,
      limit: 10,
      count: 100,
    },
    loading: false,
  });

  const [general, setGeneral] = useState();
  const [loading, setLoading] = useState(false);

  const [missions, setMissions] = useState();
  const [coin, setCoin] = useState({
    type: "",
    description: "",
    receipt: "",
  });
  const [token, setToken] = useState({
    type: "",
    description: "",
    receipt: "",
  });
  const [coinTypes, setCoinTypes] = useState();
  const [tokenTypes, setTokenTypes] = useState();

  useEffect(() => {
    try {
      setLoading(true);
      if (consumer) {
        getGeneral();
        //token
        getCollect();
        getSpend();
        getPurchase();
        //coin
        getCoinCollect();
        getCoinSpend();

        getMission();
        getTokenTypes();
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }, [consumer]);

  const getCollect = async (offset = 0, limit = 10) => {
    try {
      setCollect((prev) => ({ ...prev, loading: true }));
      const response = await Lunar2025service.getItemCollect(
        consumer._id,
        offset,
        limit
      );
      setCollect({
        list: response.data,
        pagination: {
          offset: offset,
          limit: limit,
          count: 200,
        },
        loading: false,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setCollect((prev) => ({ ...prev, loading: false }));
    }
  };
  const getSpend = async (offset = 0, limit = 10) => {
    try {
      setSpend((prev) => ({ ...prev, loading: true }));
      const response = await Lunar2025service.getItemSpend(
        consumer._id,
        offset,
        limit
      );
      setSpend({
        list: response.data,
        pagination: {
          offset: offset,
          limit: limit,
          count: 200,
        },
        loading: false,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setSpend((prev) => ({ ...prev, loading: false }));
    }
  };
  const getPurchase = async (offset = 0, limit = 10) => {
    try {
      setPurchase((prev) => ({ ...prev, loading: true }));
      const response = await Lunar2025service.getPurchase(
        consumer._id,
        offset,
        limit
      );
      setPurchase({
        list: response.data,
        pagination: {
          offset: offset,
          limit: limit,
          count: 200,
        },
        loading: false,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setPurchase((prev) => ({ ...prev, loading: false }));
    }
  };
  const getCoinCollect = async (offset = 0, limit = 10) => {
    try {
      setCoinCollect((prev) => ({ ...prev, loading: true }));

      const response = await Lunar2025service.getCoinCollect(
        consumer._id,
        offset,
        limit
      );
      setCoinCollect({
        list: response.data,
        pagination: {
          offset: offset,
          limit: limit,
          count: 100,
        },
        loading: false,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setCoinCollect((prev) => ({ ...prev, loading: false }));
    }
  };
  const getCoinSpend = async (offset = 0, limit = 10) => {
    try {
      setCoinSpend((prev) => ({ ...prev, loading: true }));
      const response = await Lunar2025service.getCoinSpend(
        consumer._id,
        offset,
        limit
      );
      setCoinSpend({
        list: response.data,
        pagination: {
          offset: offset,
          limit: limit,
          count: 100,
        },
        loading: false,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setCoinSpend((prev) => ({ ...prev, loading: false }));
    }
  };
  const getGeneral = async () => {
    try {
      const response = await Lunar2025service.getGeneral(consumer._id);
      setGeneral(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  const getMission = async () => {
    try {
      const response = await lunar2025Service.getMission(props.consumer._id);
      setMissions(response.data.data.missions);
    } catch (error) {
      console.log(error);
    }
  };
  const giveToken = async () => {
    if (
      consumer?._id &&
      currentUser?.sub &&
      token?.receipt &&
      token?.type &&
      token?.description
    ) {
      try {
        await lunar2025Service.giveToken(
          consumer._id,
          currentUser.sub,
          token.receipt,
          token.type,
          token.description
        );
        props.notify("tr", "success", "Эрх амжилттай олголоо.");
      } catch (error) {
        props.notify("tr", "danger", "Алдаа гарлаа");
      } finally {
        setToken({
          type: "",
          description: "",
          receipt: "",
        });
      }
      await getGeneral();
      await getCollect();
    } else {
      props.notify("tr", "danger", "Талбар дутуу байна.");
    }
  };
  const getCoinTypes = async () => {
    try {
      const list = await lunar2025Service.getTypes();
      setCoinTypes(list.data.data);
    } catch (err) {
      console.log(err);
    }
  };
  const getTokenTypes = async () => {
    try {
      const list = await lunar2025Service.getTypes();
      setTokenTypes(list.data.data);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Col>
        <Row>
          <Col md="6">
            <Card>
              <Loading loading={loading} />
              <Card.Header>
                <Card.Title as="h4">Хэрэглэгчийн мэдээлэл</Card.Title>
              </Card.Header>
              <Card.Body>
                <Col md="12">
                  <Row>
                    <Table
                      className="table-hover"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <thead>
                        <tr>
                          <th>Нийт цуглуулсан зоос</th>
                          <th>Нийт зарцуулсан зоос</th>
                          <th>Үлдэгдэл зоос</th>
                          <th>Нийт цуглуулсан эрх</th>
                          <th>Нийт зарцуулсан эрх</th>
                          <th>Үлдэгдэл эрх</th>
                          <th>Алаг мэлхий өрсөн тоо</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{general?.totalCoinCreationAmount}</td>
                          <td>{general?.totalCoinSpendAmount}</td>
                          <td>{general?.coinBalance}</td>
                          <td>{general?.totalQuoteCreationAmount}</td>
                          <td>{general?.totalQuoteSpendAmount}</td>
                          <td>{general?.quoteBalance}</td>
                          <td>{general?.completedTurtle?.length}</td>
                        </tr>
                      </tbody>
                    </Table>
                    {}
                  </Row>
                </Col>
              </Card.Body>
            </Card>
            <Card>
              <Card.Header>
                <Card.Title as="h4">Алаг мэлхий хонжворын дугаар</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row
                  className="table-hover"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <Table>
                    <thead>
                      <tr>
                        <th>Огноо</th>
                        <th>Ticket Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {general?.completedTurtle?.map((turtle) => (
                        <tr>
                          <td>{turtle?.completedDate?.slice(0, 16)}</td>
                          <td>{turtle?.turtleId}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col md="6">
            <Card>
              <Card.Header>
                <Card.Title as={"h4"}>Эрх нөхөн олгох</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Group controlId="lunar">
                    <label>Олгох төрөл</label>
                    <Form.Control
                      as="select"
                      value={token.type}
                      name={"box"}
                      className="form-control"
                      onChange={(e) => {
                        setToken((prevState) => ({
                          ...prevState,
                          type: e.target.value,
                        }));
                      }}
                    >
                      {tokenTypes?.map((type, ind) => (
                        <option key={ind} value={type._id}>
                          {`${type.method} - ${type.amountQuote}`}
                        </option>
                      ))}
                    </Form.Control>
                    <label>Receipt Id</label>
                    <Form.Control
                      placeholder="Receipt Id"
                      as="input"
                      value={token.receipt}
                      onChange={(e) => {
                        setToken((prevState) => ({
                          ...prevState,
                          receipt: e.target.value,
                        }));
                      }}
                      required
                    ></Form.Control>
                    <label>Дэлгэрэнгүй</label>
                    <Form.Control
                      as="input"
                      placeholder="Дэлгэрэнгүй"
                      value={token.description}
                      onChange={(e) => {
                        setToken((prevState) => ({
                          ...prevState,
                          description: e.target.value,
                        }));
                      }}
                      required
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} sm="3" controlId="formGridPassword">
                    <Button
                      style={{ marginTop: "20px" }}
                      variant="primary"
                      className="btn btn-sm"
                      size="md"
                      onClick={() => {
                        giveToken();
                      }}
                    >
                      Олгох
                    </Button>
                  </Form.Group>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col>
        <Card>
          <Loading loading={collect?.loading} />
          <Card.Header>
            <Card.Title as="h4">Эрх Цуглуулалт</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Bill Id</th>
                  <th>Огноо</th>
                  <th>Цуглуулсан эрх</th>
                  <th>Цуглуулсан төрөл</th>
                  <th>Дэд Төрөл</th>
                  <th>terminal</th>
                  <th>Тайлбар</th>
                </tr>
              </thead>
              <tbody>
                {collect?.list?.map((col, ind) => (
                  <tr key={ind}>
                    <td>{col?.uniqId}</td>
                    <td>{col?.created_at}</td>
                    <td>{col?.amount}</td>
                    <td>{col?.coinType}</td>
                    <td>{col?.subType}</td>
                    <td>{col?.terminal_token}</td>
                    <td>{col?.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Pagination
              pagination={collect?.pagination}
              onChange={getCollect}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Loading loading={spend?.loading} />
          <Card.Header>
            <Card.Title as="h4">Эрх Зарцуулалт</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Ашигласан төрөл</th>
                  <th>Огноо</th>
                  <th>Зарцуулсан эрх</th>
                  <th>Before balance</th>
                  <th>After balance</th>
                  <th>Төлөв</th>
                  <th>Таарсан урамшуулал</th>
                  <th>Төрөл</th>
                </tr>
              </thead>
              <tbody>
                {spend?.list?.map((spe, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{spe?.spendType}</td>
                      <td>{spe?.created_at}</td>
                      <td>{spe?.spendAmount}</td>
                      <td>{spe?.beforeBalance}</td>
                      <td>{spe?.afterBalance}</td>
                      <td>{spe?.finish ? "Амжилттай" : "none"}</td>
                      <td>{spe?.prize_type}</td>
                      <td>{spe?.prize_uniq}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Pagination pagination={spend?.pagination} onChange={getSpend} />
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Loading loading={purchase?.loading} />
          <Card.Header>
            <Card.Title as="h4">Эрх Худалдан авалт</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Огноо</th>
                  <th>Эрх</th>
                  <th>Нийт дүн</th>
                  <th>Гүйлгээ</th>
                  <th>токи гүйлгээ</th>
                </tr>
              </thead>
              <tbody>
                {purchase?.list?.map((col, ind) => (
                  <tr key={ind}>
                    <td>{col?.created_at}</td>
                    <td>{col?.name}</td>
                    <td>{col?.amount}</td>
                    <td>{col?.message}</td>
                    <td>{col?.order_id}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Pagination
              pagination={purchase?.pagination}
              onChange={getPurchase}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Loading loading={coinCollect?.loading} />
          <Card.Header>
            <Card.Title as="h4">Зоос Цуглуулалт</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Огноо</th>
                  <th>Цуглуулсан Зоос</th>
                  <th>Цуглуулсан төрөл</th>
                  <th>Төрөл</th>
                  <th>Тайлбар</th>
                </tr>
              </thead>
              <tbody>
                {coinCollect?.list?.map((col, ind) => (
                  <tr key={ind}>
                    <td>{col?.uniqId}</td>
                    <td>{col?.created_at}</td>
                    <td>{col?.amount}</td>
                    <td>{col?.coinType}</td>
                    <td>{col?.subType}</td>
                    <td>{col?.terminal_token}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Pagination
              pagination={coinCollect?.pagination}
              onChange={getCoinCollect}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Loading loading={coinSpend?.loading} />
          <Card.Header>
            <Card.Title as="h4">Зоос Зарцуулалт</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Ашигласан төрөл</th>
                  <th>Огноо</th>
                  <th>Зарцуулсан зоос</th>
                  <th>Before balance</th>
                  <th>After balance</th>
                  <th>Id</th>
                </tr>
              </thead>
              <tbody>
                {coinSpend?.list?.map((spe, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{spe?.spendType}</td>
                      <td>{spe?.created_at}</td>
                      <td>{spe?.spendAmount}</td>
                      <td>{spe?.beforeBalance}</td>
                      <td>{spe?.afterBalance}</td>
                      <td>{spe?.uniqId}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Pagination
              pagination={coinSpend?.pagination}
              onChange={getCoinSpend}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Card.Header>
            <Card.Title as="h4">Даалгавар</Card.Title>
          </Card.Header>
          <Card.Body>
            <Table
              className="table-hover"
              style={{
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th>Даалгавар</th>
                  <th>SUB</th>
                  <th>Биелсэн</th>
                  <th>Зоос оо авсан</th>
                  <th>Дэлгэрэнгүй</th>
                  <th>Байгуулага Сонгосон</th>
                </tr>
              </thead>
              <tbody>
                {missions?.map((main_mission) => {
                  return main_mission?.content.sub_missions?.map(
                    (mission, ind) => {
                      if (mission.type == "FIRST_PARTNER") {
                        return null;
                      } else {
                        return (
                          <tr key={ind}>
                            <td>{main_mission.type}</td>
                            <td>{mission.type}</td>
                            <td>
                              {mission.type == "INVITE" ? (
                                <div></div>
                              ) : (
                                <div>
                                  {mission.completed ? (
                                    <div style={{ color: "green" }}>
                                      Амжилттай
                                    </div>
                                  ) : (
                                    <div style={{ color: "red" }}>Үгүй</div>
                                  )}
                                </div>
                              )}
                            </td>
                            <td>
                              {mission.claimed ? (
                                <div style={{ color: "green" }}>Амжилттай</div>
                              ) : (
                                <div style={{ color: "red" }}>Үгүй</div>
                              )}
                            </td>
                            <td>{mission.description}</td>

                            <td>
                              {mission.type == "SECOND_PARTNER" ||
                              mission.type == "CROSS" ? (
                                <div>
                                  {mission?.chosen ? (
                                    <div style={{ color: "green" }}>Тийм</div>
                                  ) : (
                                    <div style={{ color: "red" }}>Үгүй</div>
                                  )}
                                </div>
                              ) : null}
                            </td>
                          </tr>
                        );
                      }
                    }
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
}
